(function (){
    'use strict';
    angular
        .module('authAppController', ['authService'])
        .controller('authAppController', authAppController);


    authAppController.$inject = ['$http', '$window', '$timeout', '$cookies', 'toastr', 'authService'];

    function authAppController ($http, $window, $timeout, $cookies, toastr, authService){

        const COMPANY_TYPES = [
            {value: 6, display: 'Acente'},
            {value: 3, display: 'Filo Şirketi'},
            {value: 1, display: 'Sigorta Şirketi'},
            {value: 2, display: 'Servis Şirketi'},
            {value: 5, display: 'Ekspertiz'},
        ]

        let vm = this;
        vm.$onInit = onInit;
        vm.login = login;
        vm.register = register;
        vm.resetPassword = resetPassword;
        vm.updatePassword = updatePassword;
        vm.loginCheckEmail = loginCheckEmail;
        vm.registerCheckEmail = registerCheckEmail;
        vm.resetCheckEmail = resetCheckEmail;
        vm.triggeredKeyDown = triggeredKeyDown;
        vm.utmSource = $window.UTM_SOURCE;
        vm.referrer = $window.REFERRER;
        vm.urlCompanyType = $window.COMPANY_TYPE;
        vm.mailingObj = $window.MAILING_OBJ;
        vm.companyTypes = COMPANY_TYPES;
        vm.initDone = false;
        vm.promise = false;
        vm.activeView = $window.VIEW_NAME || 'auth.sign-in';
        vm.loginView = {
            showPass: false,
            emailValidationRequires: true,
            emailValidationKey: 'notExists',
            form: {
                email: '',
                password: ''
            },
            checkedMails: new Map()
        };
        vm.resetPasswordView = {
            isSuccess: null,
            emailValidationRequires: true,
            emailValidationKey: 'notExists',
            form: {
                email: ''
            },
            sentList: [],
            checkedMails: new Map()
        };
        vm.recoverView = {
            isSuccess: null,
            emailValidationRequires: true,
            emailValidationKey: 'notExists',
            form: {
                email: '',
                password: '',
                passwordConfirm: '',
                passwordRec: ''
            },
            sentList: [],
            checkedMails: new Map()
        };
        vm.registerView = {
            showPass: false,
            emailValidationRequires: false,
            emailValidationKey: 'alreadyExists',
            checkedMails: new Map(),
            form: {
                companyType: window.COMPANY_TYPE||2,
                company: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                password: '',
                passwordConfirm: '',
                self_register: true
            },
        }


        function onInit (){
            vm.useKazayaptimView = vm.utmSource === 'kazayaptim.com' || $cookies.get('applicationView') === 'kazayaptim.com';
            if (vm.useKazayaptimView) {
                $cookies.put('applicationView', 'kazayaptim.com');
            }
            if (vm.mailingObj) {
                vm.registerView.form.company = vm.mailingObj.name;
                vm.registerView.form.email = vm.mailingObj.email || vm.mailingObj.email_1;
                if (vm.mailingObj.mobil_phone && vm.mailingObj.mobil_phone.startsWith('5'))
                    vm.registerView.form.phone = vm.mailingObj.mobil_phone.slice(1)

            }
            vm.initDone = true;
        }

        function triggeredKeyDown (event, _form) {
            console.log(event, _form, vm.loginView.form)
            if (event.keyCode === 13 && vm.loginView.form.password && vm.loginView.form.email) {
                login(_form)
            }
        }

        function login (triggeredForm) {
            if (vm.promise) return null;
            if (!triggeredForm.$valid) {
                toastr.warning("Lütfen form alanlarını uygun formatta doldurun", "Geçersiz Form")
                return null;
            }
            _login()
        }

        function _login () {
            vm.promise = true;
            authService
                .login(vm.loginView.form.email, vm.loginView.form.password)
                .then(({success, message, next}) => {
                    if (success) {
                        toastr.success('Yönlendiriliyorsunuz', 'Giriş Başarılı');
                        $timeout(() => {
                            location.href = next;
                        }, 300)
                    } else {
                        toastr.error(message, 'Giriş Başarısız!')
                    }
                })
                .finally(() => {
                    vm.promise = false;
                })
        }

        function resetPassword (triggeredForm) {
            if (vm.promise) return null;
            if (! triggeredForm.$valid) {
                toastr.warning("Lütfen form alanlarını uygun formatta doldurun", "Geçersiz Form")
                return null;
            }
            if (vm.resetPasswordView.sentList.indexOf(vm.resetPasswordView.form.email) !== -1) {
                toastr.info("Şifre sıfırlama isteği zaten gönderilmiş", "Email Adresinizi Kontrol Edin")
                return null;
            }
            vm.promise = true;

            authService
                .resetPassword(vm.resetPasswordView.form.email)
                .then(({success, message}) => {
                    vm.resetPasswordView.isSuccess = success;
                    if (success) {
                        toastr.success('Lütfen mail kutunuzu kontrol edin', 'İşlem Başarılı');
                        vm.resetPasswordView.sentList.push(vm.resetPasswordView.form.email)
                    } else {
                        toastr.error(message, 'İşlem Başarısız!')
                    }
                })
                .finally(() => {
                    vm.promise = false;
                })
        }

        function updatePassword (triggeredForm) {
            if (vm.promise) return null;
            if (! triggeredForm.$valid) {
                toastr.warning("Lütfen form alanlarını uygun formatta doldurun", "Geçersiz Form")
                return null;
            }
            vm.promise = true;

            authService
                .updatePassword(vm.recoverView.form)
                .then(({success, message}) => {
                    vm.recoverView.isSuccess = success;
                    if (success) {
                        toastr.success('Şifreniz başarıya değiştirildi', 'Şifre Değiştirildi');
                        vm.loginView.form.email = vm.recoverView.form.email;
                        vm.loginView.form.password = vm.recoverView.form.password;
                        _login()
                    } else {
                        toastr.error(message, 'Şifre Değiştirilmedi!')
                    }
                })
                .finally(() => {
                    vm.promise = false;
                })
        }

        function register (triggeredForm) {
            if (vm.promise) return null;
            if (! triggeredForm.$valid) {
                toastr.warning("Lütfen form alanlarını uygun formatta doldurun", "Geçersiz Form")
                return null;
            }
            vm.promise = true;
            let registerForm = angular.copy(vm.registerView.form);
            delete registerForm.passwordConfirm;
            registerForm.phone = "5" + vm.registerView.form.phone;
            registerForm.utm_source = vm.utmSource;
            registerForm.referrer = vm.referrer;
            if (vm.mailingObj)
                registerForm.mailing_id = vm.mailingObj._id.$oid;
            authService
                .register(registerForm)
                .then(({success, message, next}) => {
                    if (success) {
                        toastr.success('Üyeliğiniz oluşturuldu', 'Tebrikler');
                        vm.loginView.form.email = registerForm.email;
                        vm.loginView.form.password = registerForm.password;
                        _login();
                    } else {
                        toastr.error(message, 'İşlem Başarısız!')
                    }
                })
                .finally(() => {
                    vm.promise = false;
                })
        }

        function loginCheckEmail (_form) {
            _checkEmail(_form, vm.loginView);
        }

        function resetCheckEmail (_form) {
            vm.resetPasswordView.isSuccess = null;
            _checkEmail(_form, vm.resetPasswordView);
        }

        function registerCheckEmail (_form, delay=10) {
            console.log('registerCheckEmail', _form, delay);
            $timeout(() => {
                _checkEmail(_form, vm.registerView);
            }, delay)
        }

        function _checkEmail (_form, _viewScope) {
            const _email = _viewScope.form.email;

            _form.email.$setValidity(_viewScope.emailValidationKey, true);
            console.log("*** _viewScope.emailValidationKey", _form, _viewScope.emailValidationKey)
            if (_viewScope.checkedMails.has(_email)) {
                console.log(_viewScope.checkedMails.get(_email), _viewScope.checkedMails);
                _form.email.$setValidity(_viewScope.emailValidationKey, _viewScope.checkedMails.get(_email));
                return null
            }

            if (! _form.email.$valid) return null;

            authService
                .checkEmailExists(_email)
                .then((isExists) => {
                    _form.email.$setValidity(
                        _viewScope.emailValidationKey,
                        isExists === _viewScope.emailValidationRequires
                    );
                    _viewScope.checkedMails.set(_email, isExists === _viewScope.emailValidationRequires)
                    _form.email.$dirty = true
                });
        }
    }
})();